import { Tooltip } from '@mui/material';

import { Link01Icon } from '@/components/icons/Link01Icon';
import { COLORS } from '@/styles/tokens/colors';

import {
  ASSET_INTEGRATION_PROVIDER_DISPLAY_NAMES,
  AssetIntegrationProviders,
} from './constants';

export function IntegrationLinkedIcon({
  providerName = ASSET_INTEGRATION_PROVIDER_DISPLAY_NAMES[
    AssetIntegrationProviders.EMONEY
  ],
}: {
  providerName?: string;
}) {
  return (
    <Tooltip placement="top" title={`Linked to ${providerName}`}>
      <Link01Icon size={16} color={COLORS.TEXT.SECONDARY} />
    </Tooltip>
  );
}
